/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react';

import {generateCallback} from '/util/component.util';
import {trackLogin} from '/util/rate/rate.util';

import {DashboardProps} from './Dashboard.types';

export const useDashboard = ({
  hasHomeMetricsById = false,
  hasClientMetricsById = false,
  hasTeamsMetricsById = false,
  hasPerformanceMetrics = false,
  hasProgressionData = false,
  getClientMetrics = () => {},
  getTeamsMetrics = () => {},
  getHomeMetrics = () => {},
  getRankProgression = () => {},
  getPerformanceMetrics = () => {},
  onNavigate = () => {},
  getTeams = () => {},
  hasTeamsById = false,
  hasSameDayLastMonth = false,
  getSameDayLastMonth = () => {},
}: DashboardProps) => {
  const onSummaryPress = generateCallback({
    func: onNavigate,
    params: 'performance',
  });

  useEffect(() => {
    const fetchRankProgressionData = () => getRankProgression();

    // Preload Teams Tab Data
    if (!hasTeamsById) {
      getTeams();
    }

    if (!hasTeamsMetricsById) {
      getTeamsMetrics();
    }

    // Preload Client Tab Data
    if (!hasClientMetricsById) {
      getClientMetrics();
    }

    // Preload Dashboard Tab Data
    if (!hasHomeMetricsById) {
      getHomeMetrics();
    }

    // Preload Dashboard and Performance Tab Data
    if (!hasProgressionData) {
      fetchRankProgressionData();
    }

    // Preload Performance Tab Data
    if (!hasPerformanceMetrics) {
      getPerformanceMetrics();
    }

    //Preload same day last month metrics
    if (!hasSameDayLastMonth) {
      getSameDayLastMonth();
    }

    trackLogin();
  }, []);

  return {
    onSummaryPress,
  };
};
